module.exports = __webpack_public_path__ + "static/media/wmTrial-numbers-1.0d3f61d9.mp3";